import { gql } from "@apollo/client";

export { gql };
export default class GQL {
  constructor() {
    this.cache = {};
  }

  get(queryName) {
    // search for cache
    let query = this.cache[queryName];
    // if no cache
    if (query === undefined) {
      if (queries[queryName] === undefined) {
        return;
      }
      // generate the gql query
      query = gql(queries[queryName]);
      // cache it
      this.cache[queryName] = query;
    }
    // return the gql query
    return query;
  }
}

export const fragmentVideo = `
id
publisher
videoID
title
durationSeconds
description
embed
url
img
views
published
scoreTrending
channel {
  title
  url
  img
  description
}
papers {
  tags(where: {type:"task"}) {
    id
    name
  }
}
`;
const fragmentRepo = `
id
source
repoID
url
title
language
stars
forks
framework
owner {
  username
  avatar
}`;
//likes
//downloads
const fragmentModel = `
id
displayName
params
#scoreSota
__typename
leaderboards {
  id
  displayName
  modelsConnection(sort:{edge:{scorePosition:ASC}}) {
    edges {
      scorePerformance
      scorePosition
      node {
        id
        created
        displayName
        params
        #scoreSota
        paper {
          publisher
          paperID
          published
        }
      }
    }

  }
}
`;

export const fragmentTask = `
id
name
description
scoreTrending
count {
  stars
  papers
  models
}
`;
export const fragmentPaper = `
id
paperID
publisher
title
authors
summary
updated
published
scoreTrending
summaries(options: {limit: 1}, where: { header: "paper.summary.expertise.beginner" }) {
  summary
}
tags(where: { type: "task" }) {
  id
  name
  __typename
}
`;
const paperQuery = `
id
publisher
updated
paperID
published
authors
title
scoreTrending
summary
lastCheckedForCode
links {
  id
  type
  url
  data
}
reposConnection(
  first: 100
  sort: { node: { stars: DESC, forks: DESC } }
  where: {
    OR: [
      { NOT: { node: { blackList: true } } }
      { node: { blackList: null } }
      { edge: { official: true } }
    ]
  }
  ) {
  edges {
    official
    node {
      ${fragmentRepo}
    }
  }
}
models {
  ${fragmentModel}
}
tags(where: { type: "task" }) {
  ${fragmentTask}
  __typename
}
summaries(options: { limit: 1, sort: { model: DESC } }, where: { model: "gpt-3.5-turbo-0125", header: "paper.summary.expertise.beginner", summary_NOT: null } ) {
  model
  header
  summary
}
emailsConnection(where: { node: { privacyOptOut: null } }) {
  edges {
    author
    node {
      id
      address
      name
      avatar
      linkedin
      bio
      site
      override
      membership {
        name
      }
      paper {
        modelsAggregate {
          count
        }
      }
      github {
        avatar
        username
      }
      scholar {
        thirdPartyID
      }
      twitter {
        avatar
        username
      }
      location {
        formatted
      }
      owner {
        id
        name
        github {
          avatar
        }
        email(options: { limit: 1 }, where: { avatar_NOT: null }) {
          avatar
        }
        authored(options: { sort: { pageRank: DESC } }) {
          id
          publisher
          paperID
        }
      }
    }
  }
}
`;

export const queries = {
  // trending
  trendingTasks: `
    query trendingTasks($limit: Int) {
      tags(
        where: { scoreTrending_GT: 0 }
        options: { sort: { scoreTrending: DESC } limit: $limit }
      ) {
        ${fragmentTask}
      }
    }`,
  trendingPapers: `
    query trendingPapers($limit: Int) {
      papers(
        where: { scoreTrending_GT: 0 }
        options: { sort: { scoreTrending: DESC } limit: $limit }
      ) {
        ${fragmentPaper}
      }
    }`,
  trendingModels: `
    query trendingModels($limit: Int) {
      bytezModels(
        where: { scoreTrending_GT: 0 }
        options: { sort: { scoreTrending: DESC }, limit: $limit }
      ) {
        id
        name
        displayName
        params
        scoreTrending
        tasks {
          id
          name
          __typename
        }
        paper {
          title
          publisher
          paperID
          published
          __typename
        }
      }
    }

    `,
  // collections
  tasks: `
  query tasks {
    tags(where: { type: "task" }, options: { sort: { name: ASC } }) {
      id
      name
    }
  }`,
  tasksWithCount: `
  query tasks {
    tags(where: { type: "task" }, options: { sort: { name: ASC } }) {
      id
      name
      count {
        models
      }
    }
  }`,
  // feed
  papersByTaskTrending: `
    query papersByTaskTrending($limit: Int, $task: String) {
      papers(
        where: { pdf: true, scoreTrending_GT: 0, tags_SOME: { name: $task} }
        options: { sort: { scoreTrending: DESC } limit: $limit }
      ) {
        ${fragmentPaper}
      }
   }
  `,
  papersByTaskNew: `
    query papersByTaskNew($limit: Int, $task: String) {
      papers(
        where: { pdf: true, tags_SOME: { name: $task} }
        options: { sort: { updated: DESC } limit: $limit }
      ) {
        ${fragmentPaper}
      }
    }
  `,
  papersByTaskCount: `
    query papersByTaskCount($task: String) {
      papersAggregate(where: { tags_SINGLE: { name: $task } }) {
        count
      }
    }
  `,
  // get entity
  video: `
  query video( $id: String! ) {
    videos( where: { AND: [{id: $id}, {title_NOT: null}]} options: { limit: 1 } ) {
      ${fragmentVideo}
    }
  }
  `,
  repo: `
  query repo( $id: String! ) {
    repos( where: { id: $id } options: { limit: 1 } ) {
      ${fragmentRepo}
    }
  }
  `,
  task: `
  query task( $task: String! ) {
    tags( options: { limit: 1 } where: {name: $task, type:"task" }  ) {
      ${fragmentTask}
    }
  }
  `,
  paper: `
    query paper($id: String!) {
      papers(options: { limit: 1 }, where: { id: $id } ) {
        ${paperQuery}
      }
    }
    `,
  paperMeta: `
    query paperMeta($id: String!) {
      papers(options: { limit: 1 }, where: { id: $id } ) {
        id
        published
        title
        summary
        scoreTrending
        tags {
          name
        }
        summaries(options: { limit: 1 }, where: { header: "paper.summary.expertise.beginner" } ) {
          model
          header
          summary
        }
      }
    }
  `,
  /*
          models(where:{leaderboardsConnection_SOME:{edge:{scorePosition_LT:3}}},options:{sort:{scoreSota:DESC},limit:1}) {
         ${fragmentModel}
        }
  */
  // related to paper content
  references: `
    query references($id: String!) {
      papers(options: { limit: 1 }, where: { id: $id }) {
        referencesConnection(
          sort: { edge: { index: ASC } }
          where: { node: { NOT:{ title: null } } }
        ) {
          edges {
            index
            node {
              url
              ${fragmentPaper}
            }
          }
        }
      }
    }
  `,
  similar: `
    query Similar($id: String!) {
      top_similar_papers(
        id: $id
      ) {
        id
        pageRank
        publisher
        paperID
        authors
        title
        updated
        scoreSimilarity
      }
    }
  `,
  alsoAuthoredBy: `
    query AlsoByAuthors($id: String!) {
      also_by_authors(id: $id) {
        id
        publisher
        paperID
        updated
        title
      }
    }
  `,
  repos: `
    query repos($id: String!) {
      papers(options: { limit: 1 }, where: { id: $id }) {
        reposConnection(
          first: 100
          sort: { node: { stars: DESC, forks: DESC } }
          where: {
            OR: [
              { NOT: { node: { blackList: true } } }
              { node: { blackList: null } }
              { edge: { official: true } }
            ]
          }
          ) {
          edges {
            official
            node {
              ${fragmentRepo}
            }
          }
        }
      }
    }`,
  repoOfficial: `
    query repoOfficial($id: String!) {
      papers(options: { limit: 1 }, where: { id: $id }) {
        reposConnection( where: { edge: { official: true } }) {
          edges {
            official
            node {
              ${fragmentRepo}
              summaries(where:{header:"readme.md"}) {
                summary
              }
            }
          }
        }
      }
    }`,
  citations: `
    query citations($id: String!) {
      papers(options: { limit: 1 }, where: { id: $id }) {
        citation(options: { sort:{ numberOfCitations: DESC }, limit: 100 }, where: { title_NOT: null }) {
          ${fragmentPaper}
        }
      }
    }
`,
  author: `
    query author($id: String!) {
      emails(
        where: {
          AND: [
            { privacyOptOut: null }
            { OR: [{ id: $id },{ owner: { id:$id }}] }
          ]
        }
        options: { limit: 1 }
      ) {
        id
        name
        avatar
        linkedin
        bio
        site
        override
        paperConnection {
          edges {
            author
            node {
              id
              tags(where: { type: "task" }) {
                name
              }
            }
          }
        }
        github {
          avatar
          username
        }
        scholar {
          thirdPartyID
        }
        twitter {
          avatar
          username
        }
        location {
          formatted
        }
        owner {
          id
          name
          github {
            avatar
          }
          authored(options: { sort: { pageRank: DESC } }) {
            id
            tags(where: { type: "task" }) {
              name
            }
          }
          email(where: { id_NOT: $id }) {
            name
            avatar
            linkedin
            bio
            site
            github {
              avatar
              username
            }
            scholar {
              thirdPartyID
            }
            twitter {
              avatar
              username
            }
            location {
              formatted
            }
          }
        }
      }
    }
  `,
  // Search
  searchPapers: `
    query searchPapersMatch(
      $query: String
      $time: String
      $tag_list: [String]
      $publisher: String
      $limit: Int = 0
      $sortBy: String
    ) {
      search_papers_2_match(
        query: $query
        time: $time
        tag_list: $tag_list
        publisher: $publisher
        limit: $limit
        sortBy: $sortBy
      ) {
        ${fragmentPaper}
      }
    }`,
  searchPapers2_vector: `
    query searchPapersVector(
      $vector: [Float]
      $time: String
      $tag_list: [String]
      $publisher: String
      $limit: Int = 0
      $sortBy: String
    ) {
      search_papers_2_vector(
        vector: $vector
        time: $time
        tag_list: $tag_list
        publisher: $publisher
        limit: $limit
        sortBy: $sortBy
      ) {
        ${fragmentPaper}
      }
    }`,
  searchPapers2_no_vector: `
    query searchPapersNoVector(
      $time: String
      $tag_list: [String]
      $publisher: String
      $limit: Int = 0
      $sortBy: String
    ) {
      search_papers_2_no_vector(
        time: $time
        tag_list: $tag_list
        publisher: $publisher
        limit: $limit
        sortBy: $sortBy
      ) {
        ${fragmentPaper}
      }
    }`,
  searchPapersCount: `
    query searchPapersCount($query:String, $tag_list:[String], $time: String, $publisher: String) {
      search_papers_count(query: $query, tag_list: $tag_list, publisher: $publisher, time: $time) {
        count
      }
    }`,
  searchVideos: `
  query searchVideos(
    $query: String
    $tag_list: [String]
    $time: String
    $limit: Int
    $sortBy: String
    ) {
    search_videos(
      query: $query
      tag_list: $tag_list
      time: $time
      limit: $limit
      sortBy: $sortBy
    ) {
      ${fragmentVideo}
    }
  }
  `,
  searchVideosCount: `
    query searchVideosCount($query:String, $tag_list:[String], $time: String) {
      search_videos_count(query: $query, tag_list: $tag_list, time: $time) {
        count
      }
    }`,
  searchTasks: `
    query searchTasks( $limit: Int = 0, $query: String, $sortBy: String) {
      search_tasks(limit: $limit, query: $query, sortBy: $sortBy) {
        ${fragmentTask}
      }
    }`,
  searchTasksCount: `
    query searchTasksCount($query: String) {
      search_tasks_count(query: $query) {
        count
      }
    }`,
  conferenceTop6: `
    query conferenceTop6($id:[String!]) {
      papers(
        options: { limit:6 }
        where: { publisher:"cvpr" paperID_IN: $id }
      ) {
        ${fragmentPaper}
      }
    }`
};
